<ion-card [class.open]="isOpen">
  <ion-button class="close-button" fill="clear" size="small" (click)="close()">
    <ion-icon slot="icon-only" name="close-sharp">
    </ion-icon>
  </ion-button>
  <ion-card-content>
    <i class="icon-{{ type }}"></i>
    <div class="content">
      <h6 class="name">{{ 'TRANSPORT.' + type | uppercase | translate }}

      </h6>
      <p>
        {{ description }}
      </p>
    </div>
  </ion-card-content>
</ion-card>